import { ClientAPI } from '@/redux/api';
import { NotifyMeClientRequest } from '@/@types/client-api';

export type NotifyMeResponse = {
  success: boolean;
  message?: string;
} | null;

const notificationEndpoints = ClientAPI.injectEndpoints({
  endpoints: builder => ({
    submitNotifyMe: builder.mutation<NotifyMeResponse, NotifyMeClientRequest>({
      query: body => ({
        url: '/notify-me',
        method: 'POST',
        body,
        responseHandler: async response => {
          if (response.status === 204) return null;
          const text = await response.text();
          return text ? JSON.parse(text) : null;
        }
      })
    })
  })
});

export const { useSubmitNotifyMeMutation } = notificationEndpoints;

export default notificationEndpoints;
